import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseStatistic } from '@mtgame/core';
import { getLeaguePlayerRoute } from '@config/routes';

interface ParamType {
  id: string;
  title: string;
  percent?: boolean;
  sortParameters?: { name: string, sort: 'asc' | 'desc' }[];
}

@Component({
  selector: 'mtg-statistic-leaders',
  templateUrl: './statistic-leaders.component.html',
  styleUrls: ['./statistic-leaders.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatisticLeadersComponent implements OnChanges {
  selectedUser: BaseStatistic;
  @Input()
  statistic: BaseStatistic[];
  @Input()
  param: ParamType;
  @Input()
  seasonId: number;
  @Input()
  round: number;
  filteredStatistic: BaseStatistic[];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.param && this.statistic) {
      this.sortStatistic();
    }
  }

  sortStatistic(): void {
    this.filteredStatistic = this.statistic
      .filter(item => item[this.param.id] || this.param.id === 'safetyRate')
      .sort((a, b) => {
        if (a[this.param.id] === b[this.param.id]) {
          if (this.param.sortParameters) {
              for (const parameter of this.param.sortParameters) {
                if (a[parameter.name] !== b[parameter.name]) {
                  return parameter.sort === 'asc' ? a[parameter.name] - b[parameter.name] : b[parameter.name] - a[parameter.name];
                }
              }
            }

          return a.leaguePlayer.fullName < b.leaguePlayer.fullName ? -1 : 1;
        }
        if (this.param.id === 'safetyRate') {
          return a[this.param.id] - b[this.param.id];
        } else {
          return b[this.param.id] - a[this.param.id];
        }
      }).slice(0, 10);
    this.selectedUser = this.filteredStatistic[0];
  }

  getUserRoute(leaguePlayerId: number): string[] {
    return getLeaguePlayerRoute(leaguePlayerId);
  }
}
